import type { FunctionComponent } from "react"

import dynamic from "next/dynamic"

import { usePrefilteredJobSearch } from "@/modules/jobSearchPrefiltered/hooks/usePrefilteredJobSearch"

const DynamicMetaData = dynamic(() =>
  import("@/modules/jobSearchPrefiltered/components/PrefilteredHeader/MetaData/MetaData").then(
    module => module.MetaData
  )
)

const DynamicPageTitle = dynamic(() =>
  import("@/modules/jobSearchPrefiltered/components/PrefilteredHeader/PageTitle/PageTitle").then(
    module => module.PageTitle
  )
)

export const PrefilteredHeader: FunctionComponent = () => {
  const isPrefilteredJobSearchPage = usePrefilteredJobSearch()

  return isPrefilteredJobSearchPage ? (
    <>
      <DynamicMetaData />
      <DynamicPageTitle />
    </>
  ) : null
}
